import { StrictMode } from 'react'
import { mountRoot } from '@ovasabi/frontend-kit'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import { EditionProvider } from './edition/EditionProvider'
import { FontFaces } from './styles/fonts'
import { getBasePath } from './lib/edition'
import { sharedUiQuality } from './lib/renderQuality'
import { registerServiceWorker } from './lib/serviceWorker'
import { captureInstallPrompt } from './lib/installPrompt'
import { isNativeShell } from './lib/shell'

// The one uiQuality: its device-prior tier lands on <html data-ui-tier> before
// first paint; App feeds it measured scroll and route windows.
sharedUiQuality()

// The worker makes the web app installable, keeps the shell and static images
// warm, and is what a push notification is delivered to. It used to register
// only when someone opted into notifications, so most visitors never had one.
// Native shells bundle their own assets and receive no Web Push.
if (!isNativeShell()) registerServiceWorker()
// The browser offers installation once, before React mounts; hold that offer for the Install button.
captureInstallPrompt()

// Theme + global styles are provided per-edition inside EditionProvider so the
// whole UI restrains when the active edition changes. Hydrates the markup
// prerenderShell wrote into index.html (see src/entry-server.tsx);
// client-renders when the root is empty, as in dev.
//
// The basename is the mount prefix, so every route the router resolves is
// absolute to the origin while every path the app navigates to stays
// prefix-relative: under `/chowdash` a `navigate('/jobs')` is
// `/chowdash/jobs`, and nothing has to know which mount it is running in.
// Transport is unaffected — the API, the command socket and the projection
// gateway are all derived from the origin, never from the page path.
mountRoot(
  document.getElementById('root')!,
  <StrictMode>
    <FontFaces />
    <BrowserRouter basename={getBasePath()}>
      <EditionProvider>
        <App />
      </EditionProvider>
    </BrowserRouter>
  </StrictMode>,
)
